// downloadBlob — trigger a client-side file download for in-memory data.
//
// Frontends inline the `URL.createObjectURL` + temp `<a download>` + revoke dance
// to export CSV/JSON. This is the canonical version. `data` may be a Blob (used
// as-is, `mime` ignored) or a string/BufferSource that is wrapped in a Blob with
// the given `mime` (default `text/plain;charset=utf-8`).
export function downloadBlob(
  data: Blob | string | BufferSource,
  filename: string,
  mime = 'text/plain;charset=utf-8',
): void {
  if (typeof document === 'undefined' || typeof URL === 'undefined') return

  const blob = data instanceof Blob ? data : new Blob([data as BlobPart], { type: mime })
  const url = URL.createObjectURL(blob)
  try {
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = filename
    anchor.rel = 'noopener'
    anchor.style.display = 'none'
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
  } finally {
    // free the object URL once the navigation/click has been dispatched
    URL.revokeObjectURL(url)
  }
}
